import axios from "axios";

import {useUserStore} from './store';

import { globalConfig } from "../configuration/config";

import { useSnackbar } from 'notistack';

type ICustomAxiosError  = {
  response: { data : {data: any, messages: string[], succeeded: boolean} }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

  const { enqueueSnackbar } = useSnackbar();

  const {currentUser, disconnectUser, getToken, getRefreshToken, refreshUserToken} = useUserStore();

  const _axios = axios.create( {
    //baseURL : 'http://localhost/Welios',
    baseURL : globalConfig.get().apiUrl,

    headers: {      
      'Content-Type':'application/json',
      'Authorization': currentUser.isConnected ? `Bearer ${currentUser.token}` : ''
      }    

  });

  
  _axios.interceptors.response.use( response => response,
    async error => {
        const status = error.response ? error.response.status : null;
        // Reject promise if usual error
        if (status !== 401) {
            
            if( axios.isAxiosError(error) ) {
              const customError : ICustomAxiosError = error as unknown as ICustomAxiosError;

              if( customError.response && customError.response.data && customError.response.data.messages)
                enqueueSnackbar( customError.response.data.messages.join("\n"), { variant: 'error',
                    anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
            }

            return new Promise((resolve, reject) => {
                reject(error);
              });
        }


        // console.log('error.config.url');
        // console.log(error.config.url);
        // Logout user if token refresh didn't work or user is disabled
        if (error.config.url === '/security/user/refreshtoken' || error.response.message === 'Account_is_disabled.') {
      
            alert('refresh failled...');
            disconnectUser();
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

      //alert('getNewToken old is' + getToken());
      try {
        const token_1 = await getNewToken(getToken(), getRefreshToken(), refreshUserToken, disconnectUser);
        // New request with new token
        const config = error.config;
        //config.headers['Authorization'] = `Bearer ${token}`;
        //console.log(config);
        //console.log('1- New Token is ' );
        //console.log(token_1 );
        _axios.defaults.headers.common["Authorization"] = `Bearer ${token_1}`;
        return await new Promise((resolve_2, reject_2) => {
          axios.request(config).then(response => {
            resolve_2(response);

          }).catch((error_1) => {
            reject_2(error_1);
          });
        });
      } catch (err) {
        Promise.reject(error);
      }       
    });

    return _axios;
  };

  const getNewToken = ( token: string, refreshToken: string, refreshUserToken: (accessToken: string) => void, disconnectUser: () => void ) => new Promise( (resolve, reject) => {
    //console.log('INNN ' + `${globalConfig.get().apiUrl}/security/user/refreshtoken`);
    axios.post(`${globalConfig.get().apiUrl}/security/user/refreshtoken`, {
        accessToken : token,
        refreshToken : refreshToken
    }, ).then( reponse => {    
      //console.log('reponse');    
      //console.log(reponse);
        if(reponse.data === '') disconnectUser();
        refreshUserToken(
            reponse.data
        );
        resolve(reponse);
    })
    .catch( error => {
      // console.log('error');
      // console.log(error);
        reject(error);
    });
});